import { useReducer, Dispatch } from 'react';
import { ActionType, ActionMap } from './baseTypes';

enum DispatchTypes {
  SET_APP_SETTINGS = 'SET_APP_SETTINGS',
}

type ModuleActionType = ActionType<DispatchTypes>;

export type AppSettingsDispatch = Dispatch<ModuleActionType>;

export type AppSettings = {
  apiDomain: string;
  domain: string;
  portalCode: string;
};

const actions = {
  [DispatchTypes.SET_APP_SETTINGS]: (state: AppSettings, appSettings: AppSettings) => ({
    ...state,
    ...appSettings,
  }),
} as ActionMap<AppSettings>;

export const appSettingsActions = {
  setAppSettings: (appSettings: Partial<AppSettings>) => (dispatch: AppSettingsDispatch): void => {
    dispatch({ type: DispatchTypes.SET_APP_SETTINGS, payload: appSettings });
  },
};

const reducer = (state: AppSettings, { type, payload }: ModuleActionType) => actions[type]?.(state, payload) || state || null;

const initState: AppSettings = {
  apiDomain: '',
  domain: '',
  portalCode: '',
};

export const useAppSettingsReducer = (): [AppSettings, AppSettingsDispatch] => useReducer(reducer, initState);
